// Broker-verified quarterly market benchmarks per city landing page.
// These are static baseline anchors reviewed by the broker — NOT a live feed.
// A city WITHOUT a verified entry here renders no market-stat cards at all
// (never a "Live data pending" placeholder, never a fabricated number).
// Update the figures + asOf label each quarter as new MLS benchmarks are confirmed.
export const CITY_MARKET_BENCHMARKS = {
  "san-jose": {
    median: 1650000,
    pricePerSqft: 1050,
    source: "Santa Clara County MLS (Quarterly Benchmark)",
    asOf: "Q2 2026",
  },
  "cupertino": {
    median: 3050000,
    pricePerSqft: 1520,
    source: "Santa Clara County MLS (Quarterly Benchmark)",
    asOf: "Q2 2026",
  },
  // "palo-alto" and "los-gatos" intentionally omitted until broker-verified
  // benchmark figures are supplied — their market cards stay hidden until then.
};

export function getCityBenchmark(slug) {
  return CITY_MARKET_BENCHMARKS[slug] || null;
}
